export default __webpack_public_path__ + "static/media/drag-point-speeding.fb31b409.svg";